const Offline_Icon = ({ className = "" }) => {
  return (
    <svg
      width="16"
      height="16"
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.0001 15.1501C11.9489 15.1501 15.1501 11.9489 15.1501 8.0001C15.1501 4.05126 11.9489 0.850098 8.0001 0.850098C4.05126 0.850098 0.850098 4.05126 0.850098 8.0001C0.850098 11.9489 4.05126 15.1501 8.0001 15.1501Z"
        fill="url(#paint0_linear_462_3970)"
      />
      <path
        d="M8.79995 8.05L10.95 5.9C11.2 5.65 11.2 5.3 10.95 5.05C10.7 4.8 10.35 4.8 10.1 5.05L7.94995 7.2L5.79995 5C5.54995 4.75 5.19995 4.75 4.94995 5C4.69995 5.25 4.69995 5.6 4.94995 5.85L7.09995 8L4.94995 10.15C4.69995 10.4 4.69995 10.75 4.94995 11C5.04995 11.1 5.19995 11.2 5.39995 11.2C5.59995 11.2 5.69995 11.15 5.84995 11L7.99995 8.85L10.15 11C10.25 11.1 10.4 11.2 10.6 11.2C10.8 11.2 10.9 11.15 11.05 11C11.3 10.75 11.3 10.4 11.05 10.15L8.79995 8.05Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_462_3970"
          x1="5.46646"
          y1="4.97073"
          x2="22.9109"
          y2="19.8956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E4E4E4" />
          <stop offset="1" stop-color="#A4A4A4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Offline_Icon;
